import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { nextTick, onMounted, shallowRef, type Component } from 'vue'

import type { ContentView } from '@/models/doc'
import { annotatorRewrite18170Experiment } from '@/services/ab'
import { Sentry } from '@/services/sentry'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'AnnotatorHost18170',
  inheritAttrs: false,
},
  __name: 'AnnotatorHost18170',
  props: {
    content: {}
  },
  emits: ["highlightsRendered", "loaded"],
  setup(__props: any, { emit: __emit }) {



const props = __props

const emit = __emit

const annotatorImplementation = shallowRef<Component | null>(null)

onMounted(async () => {
  annotatorImplementation.value = await loadAnnotatorImplementation()
  await nextTick()
  emit('loaded')
})

async function loadAnnotatorImplementation(): Promise<Component> {
  try {
    if ((await annotatorRewrite18170Experiment()) === 'B') {
      return (await import('./AnnotatorRewrite.vue')).default
    }
  } catch (error) {
    Sentry.captureException(error)
  }

  return (await import('./Annotator.vue')).default
}

return (_ctx: any,_cache: any) => {
  return (annotatorImplementation.value)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(annotatorImplementation.value), _mergeProps({ key: 0 }, _ctx.$attrs, {
        content: props.content,
        onHighlightsRendered: _cache[0] || (_cache[0] = ($event: any) => (emit('highlightsRendered')))
      }), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["content"]))
    : (_openBlock(), _createElementBlock("div", _mergeProps({ key: 1 }, _ctx.$attrs, { class: "highlights-content prevent-content-drag" }), [
        _renderSlot(_ctx.$slots, "default")
      ], 16))
}
}

})